export default "__VITE_ASSET__Csf2yLjy__"